import * as types from './types';
import { SelectedInvoice } from '../../models/selected-invoice.model';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';

export const invoiceMutations = {
  [types.InvoiceData.SET.ALL] (state, payload) {
    state.invoiceData = payload;
  },
  [types.InvoiceList.SET.ALL] (state, payload) {
    state.invoiceList = payload;
  },
  [types.InvoiceListFilter.SET.ALL] (state, payload) {
    state.invoiceListFilter = payload;
  },
  [types.UPDATE_INVOICE_LIST_SCROLLTOP] (state, payload) {
    state.invoice_list_scrolltop = payload;
  },
  [types.InvoiceList.UPDATE.SINGLE] (state, payload) {
    const { invoice_id, update } = payload;
    state.invoiceList = state.invoiceList.map(i => {
      if (i.invoice_id == invoice_id) {
        return {
          ...i,
          ...update
        };
      } else {
        return i;
      }
    });
  },
  
  ...implementSetAllNavTabDetailsMutation(types.InvoiceDetails,  'invoiceDetails'),

};
